import { fromEventPattern } from 'rxjs';

export const fromJQueryEvent = (target: globalThis.JQuery<Element>, event: string) =>
  fromEventPattern<Event>(
    handler => {
      target.on(event, handler);
    },
    handler => {
      target.off(event, handler);
    },
  );

export default { fromJQueryEvent };
